module.exports = __webpack_public_path__ + "static/netflix-5f50ef0215ec5a366fee06cb295b6413.png";